// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"efeadfb2","95":"efeadfb2","700":"efeadfb2","764":"efeadfb2","880":"e5e4863e"}[chunkId] + ".chunk.css";
};